<template>
    <nav id="mobiletopnav" class="navbar navbar-expand-lg bg-light" style="z-index: 100">
        <div class="container-fluid">
            <a :href="clientConfig.clientUrl"><img :src="clientConfig.clientLogo" alt="Logo" height="36"
                    class="d-inline-block align-text-top logo " /></a>
            <ul class="navbar-nav">
                <li class="nav-item dropdown">
                    <button class="btn btn-light dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                        {{ currentSite }}
                    </button>
                    <ul class="dropdown-menu mobile-site-menu">

                        <li>
                            <a class="dropdown-item" aria-current="page" href="/">Home</a>
                        </li>
                        <li>
                            <a class="dropdown-item" href="/rules">Rules</a>
                        </li>
                        <li>
                            <a class="dropdown-item" href="/data">Data</a>
                        </li>
                        <li>
                            <a class="dropdown-item" href="/contactus">Contact Us</a>
                        </li>
                        <li>
                            <a class="dropdown-item" href="/faq">FAQ</a>
                        </li>
                        <li>
                            <a class="dropdown-item" href="/LearningModule">Learning Module</a>
                        </li>
                        <li>
                            <a class="dropdown-item" href="/SectionContent/ReleaseNotes">Release Notes</a>
                        </li>

                    </ul>
                </li>
            </ul>
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
                aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <div class="d-flex py-3" role="search">
                    <input class="form-control me-2" type="text" placeholder="Search" aria-label="Search"
                        v-model="searchString" @keyup.enter="searchFor(searchString)" />
                    <button class="btn btn-secondary" type="button" @click="searchFor(searchString)">Search</button>
                </div>
                <LeftNav />
            </div>
        </div>
    </nav>
</template>

<script>
import GDOTLogo from "/public/gdot-logo.png";
import { useRoute } from 'vue-router';
import LeftNav from "./LeftNav.vue";

// Map of url paths and the site names  in the dropdown
const sites = new Map([
    ["crashsafety", "Crash Safety"],
    ["rules", "Rules"],
    ["data", "Data"],
    ["contactus", "Contact Us"]
]);

export default {
    components: {
        LeftNav
    },
    data() {
        return {
            clientConfig: {
                clientUrl: "/",
                clientLogo: GDOTLogo,
            },
            searchString: "",
            site: ""
        };
    },
    methods:
    {
        searchFor(searchString) {
            this.$router.push({
                path: '/search',
                query: { q: searchString }
            }).catch(e => gotCaught(e))
            this.closeNav()
        },
        closeNav() {
            document.getElementById("navbarSupportedContent").classList.remove("show")
        }
    },
    computed: {
        currentSite() {
            // get current path and find first part of url and return site name
            try {
                let route = useRoute()
                let firstPath = route.params.pathMatch[0].toLowerCase()
                let site = sites.get(firstPath)
                return site
            } catch (e) {
                return "Crash Safety"
            }
        }
    }
};
</script>

<style>
#mobiletopnav {
    -webkit-filter: drop-shadow(0 1px 1px rgba(0, 0, 0, 0.2));
    -moz-filter: drop-shadow(0 1px 1px rgba(0, 0, 0, 0.2));
    -ms-filter: drop-shadow(0 1px 1px rgba(0, 0, 0, 0.2));
    -o-filter: drop-shadow(0 1px 1px rgba(0, 0, 0, 0.2));
    filter: drop-shadow(0 1px 1px rgba(0, 0, 0, 0.2));
}

.mobile-site-menu {
    position: absolute !important;
    z-index: 100 !important;

}

/* remove nav element when printed */
@media print {
    #mobiletopnav {
        display: none !important;
    }
}
</style>
